import { Button } from "@shadcn-in-nx/ui/button";
import { useTranslation } from "react-i18next";

export function CancelConfirmStep({ planName, onKeep, onConfirmCancel, isCanceling }) {
    const { t } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="text-center">
                <div className="text-4xl mb-4">😢</div>
                <h3 className="text-xl font-bold mb-2">{t("billing.supportPlans.cancel.areYouSure")}</h3>
                <p className="text-muted-foreground mb-4">
                    {t("billing.supportPlans.cancel.loseAccess")}
                </p>
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
                    <p className="text-sm">
                        {t("billing.supportPlans.cancel.currentPlanLabel")} <span className="font-semibold">{planName}</span>
                    </p>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <Button onClick={onKeep} variant="outline" disabled={isCanceling}>
                    {t("billing.supportPlans.cancel.keepSubscription")}
                </Button>
                <Button
                    onClick={onConfirmCancel}
                    disabled={isCanceling}
                    className="bg-red-600 hover:bg-red-700 text-white"
                >
                    {isCanceling ? t("billing.supportPlans.cancel.canceling") : t("billing.supportPlans.cancel.confirmCancel")}
                </Button>
            </div>
        </div>
    );
}
